import { toolsBase } from './tools-base';

export function htmlToText(v) {
    if (v === null || v === undefined) return '';
    return String(v)
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&#39;|&apos;/gi, "'")
        .replace(/&quot;/gi, '"')
        .replace(/\s+/g, ' ')
        .trim();
}

function escapeHtml(v) {
    if (v === null || v === undefined) return '';
    return String(v)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function nextFrame() {
    return new Promise(resolve => requestAnimationFrame(() => resolve()));
}

export function printReportStrings(locale, tools) {
    return {
        total: count => `${locale.t('total')}: ${tools.formatNumber(count)}`
    };
}

export async function printReport(config) {
    const {
        title,
        fetchPage,
        total,
        pageSize = 100,
        columns,
        strings,
        concurrency,
        chunkSize = 200
    } = config;

    if (!total) {
        console.warn('printReport: no data to print');
        return;
    }

    const modal = window.reportPrintModal || null;
    const originalTitle = document.title;
    const filenameBase = String(title)
        .replace(/[\\/:*?"<>|]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    let container = null;
    let finished = false;

    const teardownPrintDom = () => {
        document.body.classList.remove('printing-report');
        document.title = originalTitle;
        if (container && container.parentNode) container.parentNode.removeChild(container);
        container = null;
    };

    try {
        if (modal) modal.show(total);

        const data = await toolsBase.fetchAllPages(fetchPage, {
            total,
            pageSize,
            concurrency,
            onProgress: fetched => { if (modal) modal.setProgress('preparing', fetched, total); }
        });

        container = document.createElement('div');
        container.className = 'print-report-isolated';
        const headerCells = columns.map(c => `<th>${escapeHtml(c.header)}</th>`).join('');
        container.innerHTML =
            `<h1 class="print-report-title">${escapeHtml(title)}</h1>` +
            `<div class="print-report-meta">${escapeHtml(strings.total(data.length))} &middot; ${escapeHtml(toolsBase.formatDateTime(new Date()))}</div>` +
            `<table class="print-report-table"><thead><tr>${headerCells}</tr></thead><tbody></tbody></table>`;
        document.body.appendChild(container);
        const tbody = container.querySelector('tbody');

        for (let i = 0; i < data.length; i += chunkSize) {
            const slice = data.slice(i, i + chunkSize);
            let rowsHtml = '';
            for (const item of slice) {
                rowsHtml += '<tr>' + columns.map(c => `<td>${escapeHtml(c.value(item))}</td>`).join('') + '</tr>';
            }
            tbody.insertAdjacentHTML('beforeend', rowsHtml);
            if (modal) modal.setProgress('building', Math.min(i + chunkSize, data.length), data.length);
            await nextFrame();
        }

        if (modal) modal.close();

        document.title = filenameBase;
        document.body.classList.add('printing-report');
        await nextFrame();

        const done = () => {
            if (finished) return;
            finished = true;
            window.removeEventListener('afterprint', done);
            teardownPrintDom();
        };

        window.addEventListener('afterprint', done);
        window.print();
        setTimeout(done, 1000);
    } catch (error) {
        console.error('printReport failed:', error);
        finished = true;
        teardownPrintDom();
        if (modal) modal.close();
        throw error;
    }
}
